module.exports = __webpack_public_path__ + "b98ce2a89b76dd6d975491765fd0342c.png";